import { Button } from '@bambi/component-library/src/components/Button/Button';

import { useModal } from 'src/common/modals/useModal';
import { Modal } from 'src/common/primitives/Modal';

import {
  PreloadedMetadataValues,
  PricingWizard,
  PricingWizardMode,
} from './management/PricingWizard/PricingWizard';
import { usePreloadedMetadataValues } from './usePreloadedMetadataValues';

interface PricingWizardModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  pricingSchemeId?: string;
  mode: PricingWizardMode;
  preloadedMetadataValues?: PreloadedMetadataValues;
}

export function PricingWizardModal({
  pricingSchemeId,
  open,
  setOpen,
  mode,
  preloadedMetadataValues,
}: PricingWizardModalProps) {
  return (
    <Modal
      open={open}
      setOpen={setOpen}
      onInteractOutside={(e) => {
        e.preventDefault();
      }}
      title="Add Pricing Scheme"
    >
      <PricingWizard
        pricingSchemeId={pricingSchemeId}
        onCancel={() => {
          setOpen(false);
        }}
        mode={mode}
        onSuccess={() => {
          setOpen(false);
        }}
        preloadedMetadataValues={preloadedMetadataValues}
      />
    </Modal>
  );
}

export function AddPricingSchemeButton() {
  const { open, setOpen, openModal } = useModal();

  const { preloadedMetadataValues, handleSetOpen } = usePreloadedMetadataValues(
    { setOpen }
  );

  return (
    <>
      <Button
        dataTestId="new-pricing-scheme-button"
        onClick={openModal}
        variant="primary"
      >
        Add Pricing Scheme
      </Button>
      <PricingWizardModal
        open={open}
        setOpen={handleSetOpen}
        mode="create"
        preloadedMetadataValues={preloadedMetadataValues}
      />
    </>
  );
}
